var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
import { CommonCrypto } from "@@/Cryptography";
import { checkPasswordStrength } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
export var ResetPasswordStage;
(function (ResetPasswordStage) {
    ResetPasswordStage[ResetPasswordStage["Reset"] = 0] = "Reset";
    ResetPasswordStage[ResetPasswordStage["VerifyPin"] = 1] = "VerifyPin";
    ResetPasswordStage[ResetPasswordStage["Code"] = 2] = "Code";
})(ResetPasswordStage || (ResetPasswordStage = {}));
export class ResetPasswordStore {
    constructor() {
        this.stage = ResetPasswordStage.Reset;
        this.email = "";
        this.working = false;
        this.pin = "";
        this.recoverycode = "";
        this.newpassword = "";
        this.showRegisterDevicePassword = false;
        this.matrix = [];
        this.sessionid = "";
        makeObservable(this);
        APPEvent.addSubscriberForResentVerifyEmail((res) => {
            if (this.working && res.email === this.email.trim().toLowerCase()) {
                if (res.isactiveaccount && res.sent) {
                    this.setResetStage(ResetPasswordStage.VerifyPin);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to send verification code please try again later");
                }
                this.setWorking(false);
            }
        });
        APPEvent.addSubscriberForVerifyPinRes((res) => {
            if (this.working && this.email.toLowerCase().trim() === res.email) {
                if (!res.rebox) {
                    APPEvent.publishApperror("Sorry, failed to get your recovery box. Please contact support");
                }
                else {
                    this.mybox = JSON.parse(LetrwingCrypto.getUTF8FromBase64(res.rebox.recoverybox));
                    this.myranbox = JSON.parse(LetrwingCrypto.getUTF8FromBase64(res.rebox.randpassbox));
                    this.matrix = res.rebox.matrix;
                    this.sessionid = res.rebox.sessionid;
                    this.setResetStage(ResetPasswordStage.Code);
                }
                this.setWorking(false);
            }
        });
        APPEvent.addSubscriberForResetPasswordResponse((resp) => {
            if (this.working) {
                if (resp.ok) {
                    // if we have done this lets now reset this device?
                    window.location.reload();
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to reset password. Please try again.");
                    this.setResetStage(ResetPasswordStage.Code);
                }
            }
        });
    }
    async resetAccount() {
        if (this.working || !this.recoverycode || !this.mybox || !this.myranbox ||
            !this.newpassword || !checkPasswordStrength(this.newpassword)) {
            return;
        }
        try {
            this.setWorking(true);
            const secretpasswordStorageKey = CommonCrypto.generatePasswordUsingMatrix(this.recoverycode, this.matrix, 4);
            const skey = await LetrwingCrypto.getHash256(secretpasswordStorageKey);
            const rbytes = LetrwingCrypto.decryptSecretBox(this.myranbox, skey);
            if (!rbytes) {
                this.setWorking(false);
                APPEvent.publishApperror("Sorry, seems like your recovery code is invalid");
                return;
            }
            const secretkey = CommonCrypto.produceUserKey(this.recoverycode, rbytes);
            const res = LetrwingCrypto.decryptSecretBox(this.mybox, secretkey);
            if (!res) {
                this.setWorking(false);
                APPEvent.publishApperror("Sorry, seems like your recovery code is invalid");
                return;
            }
            const newreq = await this.resetUserPassword(this.newpassword, res, this.matrix);
            if (!newreq) {
                this.setWorking(false);
                APPEvent.publishApperror("Sorry, unable to reset password please try again later");
                return;
            }
            const req = {
                sessionid: this.sessionid,
                req: newreq
            };
            Apphandler.sendMessage("resetuserpassword", req);
        }
        catch (ex) {
            this.setWorking(false);
            APPEvent.publishApperror("Sorry, seems like your recovery code is invalid");
            return;
        }
    }
    async resetUserPassword(password, userkey, matrix) {
        const randomnonce = LetrwingCrypto.getRandomPassword();
        if (!matrix || matrix.length === 0) {
            return undefined;
        }
        const deviceregisterpassword = CommonCrypto.generatePasswordUsingMatrix(password, matrix, 2);
        const mainkey = CommonCrypto.produceUserKey(password, randomnonce);
        const passwordStorageKey = CommonCrypto.generatePasswordUsingMatrix(password, matrix, 4);
        const pkey = await LetrwingCrypto.getHash256(passwordStorageKey);
        const randpassword = LetrwingCrypto.secretBox(randomnonce, pkey);
        const passwordstorage = LetrwingCrypto.secretBox(userkey, mainkey);
        const req = {
            mainbox: LetrwingCrypto.getBase64(LetrwingCrypto.getBinFromUTF8(JSON.stringify(passwordstorage))),
            randpassword: LetrwingCrypto.getBase64(LetrwingCrypto.getBinFromUTF8(JSON.stringify(randpassword))),
            devicepassword: deviceregisterpassword
        };
        return req;
    }
    verifyPin() {
        if (this.working || !this.pin) {
            return;
        }
        this.setWorking(true);
        const req = {
            email: this.email.toLowerCase().trim(),
            pin: this.pin
        };
        console.log(req);
        Apphandler.sendMessage("resetpasswordemailpin", req);
    }
    verifyEmail() {
        if (this.working || !this.email.trim()) {
            return;
        }
        this.setWorking(true);
        Apphandler.sendMessage("resetpasswordemail", this.email.trim().toLowerCase());
    }
    setNewPassword(pwd) {
        this.newpassword = pwd;
    }
    setRecoveryCode(code) {
        this.recoverycode = code;
    }
    setPin(pin) {
        this.pin = pin;
    }
    setShowRecoveryPassword(show) {
        this.showRegisterDevicePassword = show;
    }
    setEmail(email) {
        this.email = email;
    }
    setWorking(working) {
        this.working = working;
    }
    setResetStage(stage) {
        this.stage = stage;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], ResetPasswordStore.prototype, "stage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "working", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "pin", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "recoverycode", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "newpassword", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ResetPasswordStore.prototype, "showRegisterDevicePassword", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setNewPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setRecoveryCode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setPin", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setShowRecoveryPassword", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setEmail", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setWorking", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ResetPasswordStore.prototype, "setResetStage", null);
